import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Skeleton } from '@crehana/ui';
import { useUITheme } from '@crehana/web';

interface SkeletonAnimatedProps {
  className?: string;
  isPrimary?: boolean;
}

const SkeletonAnimated: FC<React.PropsWithChildren<SkeletonAnimatedProps>> = ({
  className,
  isPrimary,
}) => {
  const { isDark } = useUITheme();

  return (
    <Skeleton
      isAnimated
      isDark={isDark}
      className={className}
      style={
        isPrimary
          ? {
              background:
                'linear-gradient(to right, var(--color-primary-light-300) 8%, var(--color-primary-light-400) 18%, var(--color-primary-light-300) 33%)',
              backgroundSize: '200% 100%',
            }
          : undefined
      }
    />
  );
};

export default SkeletonAnimated;
